import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import styles from 'src/styles/common.module.scss'

const BREAKPOINT_RULES: Record<string, string[]> = {
    desktop: ['CONSIGUE'],
    small: ['RUEDA', 'CONSIGUE'],
}

export const TextHeaderEs = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')
    let breakAfterWords = BREAKPOINT_RULES.small

    if (isDesktop) {
        breakAfterWords = BREAKPOINT_RULES.desktop
    }

    return (
        <HighlightedText
            text="GIRA LA RUEDA Y CONSIGUE GIROS GRATIS"
            highlights={[{ word: 'GIROS' }, { word: 'GRATIS' }]}
            breakAfterWords={breakAfterWords}
            className={styles.text_header}
        />
    )
}
